import React from 'react';
import styles from './Terms.module.css';


export default function PrivacyPolicy() {
    return (
        <div>

<div className={styles.logoSection} onClick={() => window.location.href = '/'}
            role="button"
            tabIndex={0}
            onKeyPress={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                window.location.href = '/';
            }
            }}>
            <img
                src="/assets/3-0/MIC-logo-transparent.png"
                alt="Map in Color"
                className={styles.logo}
            />
        </div>

           
            <iframe
                src="/privacy-content.html"
                style={{ width: '100%', height: '100vh', border: 'none' }}
                title="Privacy Policies"
            ></iframe>
        </div>
    );
}